(() => {
  const emptyCartCustom = () => jQuery.post('/cart/clear.js')
    .done(() => location.reload());

  // Funzione di svuotamento carrello cliccando dove data-quantity='0' in un prodotto se è presente il Pacco
  const clearCart = (btn) => {
    if (!btn.hasAttribute("data-removeProduct")) return;

    // let numberQt = btn.getAttribute("data-quantity");
    btn.addEventListener('click', (e) => {
      let numberQt = e.currentTarget.getAttribute("data-quantity");
      if (numberQt > 0) return;
      let checkPack = document.getElementById('Packaging-wrapper').getAttribute('data-thereIsPack');
      jQuery.get('/cart.js').done(function (data) {
        let cartPD = JSON.parse(data).item_count;
        if ((cartPD == 2 && checkPack == 'true')) {
          emptyCartCustom();
        }
      });
    });
  }

  const clickEvent = (e) => {
    let checkbox = e.currentTarget.querySelector('input[name="package-radio"]');
    if (checkbox.checked) {
      addPackageToCart(checkbox.getAttribute('data-packageId'));
    }
  }

  const addPackageToCart = (packId) => jQuery.post(
    '/cart/add.js',
    {
      items: [
        {
          quantity: 1,
          id: packId,
        }
      ]
    }
  ).done(() => location.reload());

  document.addEventListener('cart:rerender', () => (
    setTimeout(() => {
      document.querySelectorAll('[data-quantity]')
        .forEach((qt) => clearCart(qt));
      document.querySelectorAll('.packaging_radio')
        .forEach(el => el.addEventListener('click', clickEvent))
    }, 500)
  ));
})()
